// extracted by mini-css-extract-plugin
export var active = "_8z-a";
export var activeIndicator = "_8z-9";
export var disabled = "_8z-b";
export var fullWidth = "_8z-2";
export var lg = "_8z-7";
export var md = "_8z-6";
export var redoButtonTabGroup = "_8z-0";
export var sm = "_8z-5";
export var tabButton = "_8z-4";
export var tabButtonsContainer = "_8z-1";
export var themeDestructive = "_8z-d";
export var themeNormal = "_8z-c";
export var themeSuccess = "_8z-e";
export var xl = "_8z-8";
export var xs = "_8z-3";